import { useQuery } from "@tanstack/react-query";
import useStore from "./use-store";
import { generateSecurityMeilisearchKey } from "src/api/lib/generate-security-meilisearch-key";
import { securityMeilisearchSearchKeyKeys } from "src/api/query-keys/security-meilisearch-search-key";

export const useGenerateSecuritySearchKey = (enabled = true) => {
  const { user } = useStore();

  return useQuery({
    queryFn: generateSecurityMeilisearchKey,
    queryKey: securityMeilisearchSearchKeyKeys.detail(user?.siteToken ?? ""),
    enabled,
  });
};
